<template>
  <footer class="layout-footer">
    <ul class="layout-footer__link">
      <li><a href="http://www.gameley.com/">公司简介</a></li>
      <li><a href="http://www.gameley.com/partner">合作伙伴</a></li>
      <li><a href="http://www.gameley.com/company">联系我们</a></li>
      <li><a href="http://www.gameley.com/recruitment">加入我们</a></li>
      <li><a href="http://www.gameley.com/webWeb/agreement.jsp">服务协议</a></li>
    </ul>
    <p class="layout-footer__link">© 2017 北京华夏乐游科技股份有限公司 版权所有 | 京ICP备14053809号 | 京ICP证160932号 | 京网文[2016]2088-236号</p>
    <p>抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</p>
  </footer>
</template>
<script>
export default {
  name: 'GlLayoutFooter',
  componentName: 'GlLayoutFooter'
}
</script>




// WEBPACK FOOTER //
// src/components/layout/Footer.vue